<template>
  <div class="animated fadeIn">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6">
              <label>Start Date</label>
              <kendo-datepicker class="form-control" v-model="startDate" format="dd-MM-yyyy"></kendo-datepicker>
            </div>
            <div class="col-12 col-md-6">
              <label>End Date</label>
              <kendo-datepicker class="form-control" v-model="endDate" format="dd-MM-yyyy"></kendo-datepicker>
            </div>
          </div>
        </div>
        <div class="card-footer text-right">
          <div class="btn-group">
            <button class="btn btn-secondary" type="button" @click="refresh">
              Get Report!
            </button>
            <button type="button" class="btn btn-lg btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="sr-only">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <button class="dropdown-item" >Export Data</button>
            </div>
          </div>
        </div>
      </div>
      <kendo-pivotdatasource ref="stockmovement"
          :transport-read="stockPivot"
          :schema-cube="pivot.schema"
          :measures="pivot.measures">
        <kendo-pivot-column :name="'dates'"></kendo-pivot-column>
        <kendo-pivot-row :name="'product_name'"></kendo-pivot-row>
      </kendo-pivotdatasource>
      <div class="row m-0">
        <kendo-pivotconfigurator id="configurator"
            class="d-none d-md-block col-md-2 p-0"
            :data-source-ref="'stockmovement'"
            :filterable="true"
            :height="600">
        </kendo-pivotconfigurator>
        <kendo-pivotgrid id="pivotgrid"
            class="col-12 col-md-10 p-0"
            :data-source-ref="'stockmovement'"
            :filterable="true"
            :orderable="true"
            :columnWidth="120"
            :height="600">
        </kendo-pivotgrid>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      // data here
      startDate: moment().subtract(parseInt(moment().format('DD')) - 1, 'days').format('DD-MM-YYYY'),
      endDate: moment().format('DD-MM-YYYY'),
      pivot: {
        measures: ['OUT'],
        schema: {
          dimensions: {
            product_name: { caption: 'Product' },
            dates: { caption: 'Date' }
          },
          measures: {
            'IN': { field: 'inbound', aggregate: 'sum', format: '{0:n0}' },
            'OUT': { field: 'outbound', aggregate: 'sum', format: '{0:n0}' }
          }
        }
      }
    }
  },
  methods: {
    refresh () {
      console.log('refreshing pivot ..')
      this.$refs.stockmovement.kendoDataSource.read()
    },
    stockPivot (event) {
      var vm = this
      vm.axios.get('api/report/stock/all/?date=' + encodeURIComponent(moment(vm.startDate, 'DD-MM-YYYY').format('YYYYMMDD') + ';' + moment(vm.endDate, 'DD-MM-YYYY').format('YYYYMMDD')))
        .then(
          (response) => {
            console.log(response)
            event.success(response.data)
          }
        )
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/report/StockMovement.vue